import React from 'react';
import { Link as Lk } from 'gatsby';
import css from './header.module.scss';
import logo from 'img/logo.png';
import arrow from 'img/nav_arrow.png';
import arrow_on from 'img/nav_arrow_on.png';

const nav = [
  // 首页
  {
    title: '首页',
    path: '/',
  },

  // 产品中心
  {
    title: '产品中心',
    path: '/product/home',
    nav2: [{
      title: '大数据营销服务',
      path: '/product/data',
    }, {
      title: '微加',
      path: '/product/vj',
    }, {
      title: '微加智慧党建',
      path: '/product/zhdj',
    }],
  },

  // 关于博科思
  {
    title: '关于博科思',
    path: '/about/home',
    nav2: [{
      title: '企业简介',
      path: '/about/introduction',
    }, {
      title: '荣誉资质',
      path: '/about/honor',
    }, {
      title: '企业文化',
      path: '/about/culture',
    }, {
      title: '联系我们',
      path: '/about/contact',
    }],
  },

  // 招贤纳才
  {
    title: '招贤纳才',
    path: '/recruit',
  },

  // 初灵集团
  {
    title: '初灵集团',
    path: 'http://www.cncr-it.com',
    isAbsolute: true,
    nav2: [{
      title: '杭州初灵信息技术股份有限公司',
      path: 'http://www.cncr-it.com',
      isAbsolute: true,
    }, {
      title: '深圳市博瑞得科技有限公司',
      path: 'http://www.broadtech.com.cn',
      isAbsolute: true,
    }, {
      title: '网经科技（苏州）有限公司',
      path: 'http://www.itibia.com.cn',
      isAbsolute: true,
    }, {
      title: '北京视达科科技有限公司',
      path: 'http://www.starcor.com',
      isAbsolute: true,
    }],
  },
];

const Link = props => {
  if (props.absolute) {
    return <a {...props} href={props.to} children={props.children} target="_blank" rel="noopener noreferrer" />
  }
  return <Lk {...props} children={props.children} />
}

const changeImg = (id, src) => () => {
  const imgDom = document.getElementById(id)
  if (imgDom) imgDom.src = src;
}

class Header extends React.Component {
  render() {
    let pathname;
    try {
      pathname = window.location.pathname;
    } catch (e) {
      pathname = '';
    }
    return (
      <div className={css.header}>
        <div className={css.fixed}>
          <Lk className={css.logo_box} to="/" >
            <h1 className={css.keyword}>杭州博科思科技有限公司</h1>
            <img className={css.logo} src={logo} alt="" />
          </Lk>
          <div className={css.nav_bar}>
            {
              nav.map((item, index) => {
                let isActive = ''
                const _path = item.isAbsolute ? '初灵' : '/' + item.path.split('/')[1];
                if (item.path === '/') {
                  isActive = pathname === '/';
                } else {
                  isActive = pathname.includes(_path);
                }
                return (
                  <div
                    key={index}
                    className={`${css.nav_item} ${isActive ? css.active : ''}`}
                    onMouseEnter={changeImg(`img-${index}`, arrow_on)}
                    onMouseLeave={changeImg(`img-${index}`, isActive ? arrow_on : arrow)}
                  >
                    <Link to={item.path} absolute={item.isAbsolute ? 1 : 0} className={css.nav_link}>
                      {item.title}
                      {
                        item.nav2 &&
                        <img
                          src={isActive ? arrow_on : arrow}
                          id={`img-${index}`}
                          className={css.arrow}
                          alt=""
                        />
                      }
                    </Link>
                    {
                      item.nav2 &&
                      <div className={css.nav_level2}>
                        {
                          item.nav2.map((item2, index2) => {
                            return (
                              <React.Fragment key={`${index}-${index2}`}>
                                <Link to={item2.path} absolute={item2.isAbsolute ? 1 : 0} className={css.nav_level2_item}>{item2.title}</Link>
                              </React.Fragment>
                            )
                          })
                        }
                      </div>
                    }
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    )
  }
}

export default Header;
